export default __webpack_public_path__ + "static/media/nor.118053ca.png";